import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
// Logo links to home
import { useAuth } from "../contexts/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { GraduationCap } from "@phosphor-icons/react";

const SBL_LOGO = "/sbl-logo.jpeg";

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const result = await login(email, password);
    setLoading(false);
    if (result.success) {
      if (result.data?.must_change_password) {
        navigate("/change-password");
      } else {
        navigate("/dashboard");
      }
    } else {
      setError(result.error);
    }
  };

  return (
    <div className="min-h-screen flex">
      {/* Left - Hero */}
      <div className="hidden lg:flex lg:w-1/2 relative overflow-hidden">
        <img
          src="https://static.prod-images.emergentagent.com/jobs/8f8a1e34-b7b5-4fc0-b7ca-0a56778fb2cb/images/74b52de1c3edfe940fd688e7e695f0aa82437d308d3f65927c1ab51bbf4c30a1.png"
          alt="Leadership"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-slate-950/40" />
        <div className="relative z-10 flex flex-col justify-end p-12">
          <h1 className="text-4xl font-bold tracking-tight text-white mb-3" style={{ fontFamily: "'Outfit', sans-serif" }}>
            School Builder Lab Africa
          </h1>
          <p className="text-lg text-white/80 max-w-md" style={{ fontFamily: "'IBM Plex Sans', sans-serif" }}>
            Developing the next generation of visionary leaders through world-class education and mentorship.
          </p>
        </div>
      </div>

      {/* Right - Form */}
      <div className="flex-1 flex items-center justify-center p-8 bg-white">
        <div className="w-full max-w-sm">
          <Link to="/" className="flex items-center gap-2 mb-8 no-underline" data-testid="logo-home-link">
            <img src={SBL_LOGO} alt="SBL" className="w-10 h-10 object-contain rounded-sm" />
            <span className="text-xl font-bold tracking-tight text-slate-950" style={{ fontFamily: "'Outfit', sans-serif" }}>
              School Builder Lab Africa
            </span>
          </Link>

          <h2 className="text-2xl font-semibold tracking-tight text-slate-900 mb-1" style={{ fontFamily: "'Outfit', sans-serif" }}>
            Sign In
          </h2>
          <p className="text-sm text-slate-500 mb-6">Access your educational learning dashboard</p>

          {error && (
            <div className="bg-red-50 border border-red-200 text-red-700 text-sm px-4 py-3 mb-4" data-testid="login-error">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <Label htmlFor="email" className="text-slate-700 text-sm font-medium">Email</Label>
              <Input
                id="email"
                type="email"
                placeholder="you@example.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                data-testid="login-email-input"
                className="mt-1.5 rounded-none border-slate-300 focus:border-blue-800 focus:ring-1 focus:ring-blue-800"
              />
            </div>
            <div>
              <Label htmlFor="password" className="text-slate-700 text-sm font-medium">Password</Label>
              <Input
                id="password"
                type="password"
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                data-testid="login-password-input"
                className="mt-1.5 rounded-none border-slate-300 focus:border-blue-800 focus:ring-1 focus:ring-blue-800"
              />
            </div>
            <Button
              type="submit"
              disabled={loading}
              data-testid="login-submit-btn"
              className="w-full bg-blue-800 text-white hover:bg-blue-900 rounded-none font-medium h-11 transition-all active:scale-[0.98]"
            >
              {loading ? "Signing in..." : "Sign In"}
            </Button>
          </form>

          <p className="text-center text-sm text-slate-500 mt-6">
            Don't have an account?{" "}
            <Link to="/register" className="text-blue-800 font-medium hover:underline" data-testid="go-to-register">
              Create Account
            </Link>
          </p>
          <p className="text-center mt-2">
            <span className="text-xs text-slate-400">
              Forgot your password? Contact your administrator.
            </span>
          </p>

        </div>
      </div>
    </div>
  );
}
